import { useCallback } from 'react'
import { useDispatch, useStore } from 'react-redux'
import type { ProdutoCatalogo } from '../api'
import type { RootState } from '../store'
import { adicionarItem, atualizarQuantidade, type ItemCarrinho } from '../store/carrinho-slice'
import { uuidLocal } from './id'
import { rastrearAdicionouProduto } from './tracking'

/** De onde veio o toque, só para o analytics. */
export interface OrigemAdicao {
  /** Grupo do produto no cardápio. */
  categoria?: string
  /** Faixa da tela que ofereceu o produto (ex.: "Peça também"). */
  lista?: string
}

/** Linha "simples" do produto: sem passos — a que o "+" de um toque mexe. */
export function linhaSimples(itens: ItemCarrinho[], idProduto: number): ItemCarrinho | undefined {
  return itens.find((i) => i.idProduto === idProduto && !(i.passos?.length ?? 0))
}

/** Põe 1 unidade do produto no carrinho, sem escolha: soma na linha simples que já existe ou cria uma. */
export function useAdicionarProdutoSimples(): (produto: ProdutoCatalogo, origem?: OrigemAdicao) => void {
  const dispatch = useDispatch()
  const store = useStore<RootState>()

  return useCallback(
    (produto: ProdutoCatalogo, origem: OrigemAdicao = {}) => {
      // Lê o carrinho na hora do toque, não o do último render: toques seguidos somam certo.
      const linha = linhaSimples(store.getState().carrinho.itens, produto.id)

      if (linha) {
        dispatch(atualizarQuantidade({ id: linha.id, quantidade: linha.quantidade + 1 }))
      } else {
        dispatch(
          adicionarItem({
            id: uuidLocal(),
            idProduto: produto.id,
            nome: produto.descricao,
            quantidade: 1,
            precoUnitario: produto.valor,
            faixasPreco: produto.faixasPreco,
          }),
        )
      }

      rastrearAdicionouProduto({
        id: produto.id,
        nome: produto.descricao,
        valor: produto.valor,
        quantidade: 1,
        categoria: origem.categoria,
        lista: origem.lista,
      })
    },
    [store, dispatch],
  )
}
